import { Box, Typography } from '@mui/material'
import React from 'react'

export interface DateTabProps {
    date: string
    day: string
    price: string
    isSelected: boolean
    isLowest: boolean
    onClick: () => void
    variant?: 'desktop' | 'mobile'
}

const DateTab: React.FC<DateTabProps> = ({ date, day, price, isSelected, isLowest, onClick, variant = 'desktop' }) => {
    const isMobile = variant === 'mobile'

    if (isMobile) {
        return (
            <Box
                onClick={onClick}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    width: 94,
                    height: 61,
                    minWidth: '84px',
                    pt: '12px',
                    pb: 0,
                    position: 'relative',
                    backgroundColor: isSelected ? '#EFF6FF' : 'transparent',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        backgroundColor: isSelected ? theme => theme.palette.action.hover : 'action.hover'
                    }
                }}
            >
                {/* Main content box */}
                <Box
                    sx={{
                        width: 94,
                        height: 37,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '4px',
                        px: '4px'
                    }}
                >
                    {/* Date text */}
                    <Typography
                        sx={{
                            fontWeight: isSelected ? 600 : 400,
                            fontSize: '14px',
                            lineHeight: '100%',
                            textAlign: 'center',
                            color: isSelected ? 'primary.main' : 'text.secondary',
                            letterSpacing: 0
                        }}
                    >
                        {day}, {date}
                    </Typography>

                    {/* Price text */}
                    <Typography
                        sx={{
                            fontWeight: isSelected ? 600 : 400,
                            fontSize: '12px',
                            lineHeight: '100%',
                            textAlign: 'center',
                            color: isSelected ? 'primary.main' : isLowest ? 'success.main' : 'text.primary',
                            letterSpacing: 0
                        }}
                    >
                        {price}
                    </Typography>
                </Box>

                {/* Selected indicator */}
                {isSelected && (
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: 3,
                            bgcolor: 'primary.main',
                            borderRadius: '0 0 8px 8px'
                        }}
                    />
                )}
            </Box>
        )
    }

    // Desktop version remains the same
    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                px: 1,
                pt: 1,
                borderRadius: 1,
                width: 'auto',
                flex: 1,
                maxWidth: '120px',
                minWidth: '80px',
                transition: 'all 0.2s ease',
                '&:hover': {
                    backgroundColor: 'action.hover'
                }
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    color: isSelected ? 'primary.main' : 'text.secondary',
                    fontWeight: isSelected ? 600 : 400,
                    fontSize: 12,
                    mb: 0.5,
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
                {day}, {date}
            </Typography>
            <Typography
                variant="subtitle2"
                sx={{
                    color: isSelected ? 'primary.main' : isLowest ? 'success.main' : 'text.primary',
                    fontWeight: isSelected ? 700 : 500,
                    fontSize: 13,
                    textAlign: 'center',
                    lineHeight: 1.2
                }}
            >
                {price}
            </Typography>
            {isSelected && (
                <Box
                    sx={{
                        height: 3,
                        width: '60%',
                        bgcolor: 'primary.main',
                        borderRadius: 2,
                        mt: 1
                    }}
                />
            )}
        </Box>
    )
}

export default DateTab
